// @flow

import React from 'react'
import {connect} from 'react-redux'
import {portfoliosActions} from '@/store'
import GoSync from 'react-icons/lib/go/sync'

type Props = {
  refreshExportsData: () => void,
}

const RawSyncButton = (props: Props) =>
  <button id='exports_refresh_button'
    className="btn btn-success refresh-button"
    onClick={props.refreshExportsData}
  >
    <GoSync/>
  </button>

export default connect(
  null,
  portfoliosActions,
)(RawSyncButton)



// WEBPACK FOOTER //
// ./src/views/exports-page/refresh-button.js